module.exports = __webpack_public_path__ + "static/media/Badge_SvgFormationRSE_disabled.af3d6b6e.svg";